import { z, ZodType } from 'zod';
import { jFileLittle, jFileLittleSchema } from '../file';
import { WidgetsName, WidgetType } from './common';
import { zObject } from '../../util/zod';

export type WidgetArticleImageContent = {
    file?: jFileLittle;
    useFilter?: boolean;
};
export const widgetArticleImageContentSchema = zObject<WidgetArticleImageContent>({
    file: jFileLittleSchema.optional(),
    useFilter: z.boolean().optional(),
});

export type WidgetArticleImageType = {
    name: WidgetsName.ArticleImage;
    uniqid: string;
    content: WidgetArticleImageContent;
};
export const widgetArticleImageTypeSchema = zObject<WidgetArticleImageType>({
    name: z.literal(WidgetsName.ArticleImage),
    uniqid: z.string(),
    content: widgetArticleImageContentSchema,
}) satisfies ZodType<WidgetType<WidgetArticleImageContent>>;
